import React, { useState } from 'react';
import ViewToggle from './view-toggle';

export const ListCardContainer: React.FC<{
  children: React.ReactElement;
  isInsideDataView?: boolean;
}> = ({ children, isInsideDataView = false }) => {
  const [viewType, setViewType] = useState<'tile' | 'list'>('tile');

  return (
    <div className={`w-full`}>
      {!isInsideDataView && (
        <div className="flex justify-end mb-1 px-4">
          <ViewToggle viewType={viewType} onChange={setViewType} />
        </div>
      )}

      <div
        className={`${
          viewType === 'tile'
            ? 'gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
            : 'flex flex-col gap-4'
        } ${!isInsideDataView ? 'max-h-[calc(100vh-200px)] overflow-y-auto mb-6 p-4' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};
